module.exports = __webpack_public_path__ + "media/icons/tapicerka-welurowa-unactive-9ee5cb47.png";